import axios from 'axios';
import { Message } from 'element-ui';

// const service = axios.create({
//   baseURL: 'http://localhost:3000/api',
//   timeout: 10000,
// });
// 服务器端
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3000/api',
  timeout: 10000,
});
// const service = axios.create({
//   baseURL: '/api', // 生产环境使用相对路径
//   timeout: 10000,
// });

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res.code !== '200') {
      const hasToken = localStorage.getItem('token');
      
      // 如果是 401 且有 Token，说明是 Token 过期或密码被改
      if (res.code === '401' && hasToken) {
        Message({
          message: res.msg || '登录状态已过期，请重新登录',
          type: 'warning',
          duration: 2000
        });
        setTimeout(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          // 如果不在登录页，刷新页面回到登录页
          if (window.location.pathname !== '/login' && !window.location.pathname.includes('loginjiaxiao')) {
             location.reload(); 
          }
        }, 1000);
        return Promise.reject(new Error(res.msg));
      }

      // 其他错误（如登录时的密码错）只提示不跳转
      Message({
        message: res.msg || '操作失败',
        type: 'error',
        duration: 3000
      });

      return Promise.reject(new Error(res.msg));
    } else {
      return res;
    }
  },
  error => {
    let msg = '网络异常，请稍后重试';
    if (error.response) {
      if (error.response.status === 500) msg = '服务器内部错误';
      else if (error.response.status === 404) msg = '请求资源不存在';
      else msg = `连接错误: ${error.response.status}`;
    } else if (error.request) {
      msg = '无法连接到服务器，请检查后端是否运行';
    }
    Message({ message: msg, type: 'error', duration: 3000 });
    return Promise.reject(error);
  }
);

export default service;